import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=c352cb8e&"
import script from "./Channel.vue?vue&type=script&lang=js&"
export * from "./Channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c352cb8e')) {
      api.createRecord('c352cb8e', component.options)
    } else {
      api.reload('c352cb8e', component.options)
    }
    module.hot.accept("./Channel.vue?vue&type=template&id=c352cb8e&", function () {
      api.rerender('c352cb8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Channel.vue"
export default component.exports